import { render, staticRenderFns } from "./merchantQrcodeInfo.vue?vue&type=template&id=bcc0c1b2&scoped=true&"
import script from "./merchantQrcodeInfo.vue?vue&type=script&lang=js&"
export * from "./merchantQrcodeInfo.vue?vue&type=script&lang=js&"
import style0 from "./merchantQrcodeInfo.vue?vue&type=style&index=0&id=bcc0c1b2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc0c1b2",
  null
  
)

export default component.exports